import(/* webpackMode: "eager", webpackExports: ["VideoPlayer"] */ "/app/src/app/[locale]/(main)/(home)/_components/Pools/VideoPlayer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(main)/pools/[slug]/_components/PoolChartSectionWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(main)/pools/[slug]/_components/PoolsBenefitsItems/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(main)/pools/[slug]/_components/PoolsToken/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/accordion.tsx");
